const pathName = window.location.origin;

export const emojis = [
  {
    name: 'happy-melting',
    url: pathName + '/emojis/happy-melting.png',
  },
  {
    name: 'broken-heart-on-fire',
    url: pathName + '/emojis/broken-heart-on-fire.png',
  },
  {
    name: 'angry-love',
    url: pathName + '/emojis/angry-love.png',
  },
  {
    name: 'thumbs-down-smiling',
    url: pathName + '/emojis/thumbs-down-smiling.png',
  },
  {
    name: 'celebrate-sad',
    url: pathName + '/emojis/celebrate-sad.png',
  },
  {
    name: 'star-face-yawning',
    url: pathName + '/emojis/star-face-yawning.png',
  },
  {
    name: 'not-hundred-points',
    url: pathName + '/emojis/not-hundred-points.png',
  },
];
